import React from 'react'
import PropTypes from 'prop-types'

const QuestionIcon = (props) => {
  const { color, classes, style } = props
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.431641C15.5228 0.431641 20 4.90879 20 10.4316C20 15.9545 15.5228 20.4316 10 20.4316C4.47715 20.4316 0 15.9545 0 10.4316C0 4.90879 4.47715 0.431641 10 0.431641ZM10 2.43164C5.58172 2.43164 2 6.01336 2 10.4316C2 14.8499 5.58172 18.4316 10 18.4316C14.4183 18.4316 18 14.8499 18 10.4316C18 6.01336 14.4183 2.43164 10 2.43164ZM10 14.4316C10.5523 14.4316 11 14.8794 11 15.4316C11 15.9839 10.5523 16.4316 10 16.4316C9.44772 16.4316 9 15.9839 9 15.4316C9 14.8794 9.44772 14.4316 10 14.4316ZM10 4.43164C12.2091 4.43164 14 6.2225 14 8.43164C14 10.2264 12.8179 11.7452 11.1898 12.2517L11 12.3056V12.4316C11 12.9839 10.5523 13.4316 10 13.4316C9.48716 13.4316 9.06449 13.0456 9.00673 12.5483L9 12.4316V11.4316C9 10.9188 9.38604 10.4961 9.88338 10.4384L10.1493 10.4262C11.1841 10.3498 12 9.486 12 8.43164C12 7.32707 11.1046 6.43164 10 6.43164C8.89543 6.43164 8 7.32707 8 8.43164C8 8.98392 7.55228 9.43164 7 9.43164C6.44772 9.43164 6 8.98392 6 8.43164C6 6.2225 7.79086 4.43164 10 4.43164Z"
        fill={color}
      />
    </svg>
  )
}

QuestionIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(QuestionIcon)
